import { render, staticRenderFns } from "./liveAnswers.vue?vue&type=template&id=5acecb1e&scoped=true"
import script from "./liveAnswers.vue?vue&type=script&lang=js"
export * from "./liveAnswers.vue?vue&type=script&lang=js"
import style0 from "./liveAnswers.vue?vue&type=style&index=0&id=5acecb1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acecb1e",
  null
  
)

export default component.exports